import React from 'react';
import Form from 'react-bootstrap/Form';
import MASpinner from '../../common/MASpinner';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { invoiceNoteAdd } from '../../../lib/redux/actions/invoiceNote';
import { renderField } from '../../../lib/helper/form';
import { invoiceSingleFetch } from '../../../lib/redux/actions/invoices';

const mapDispatchToProps = {
  invoiceNoteAdd,
  invoiceSingleFetch,
};

class CreateInvoiceNoteForm extends React.Component {
  onSubmit(values) {
    const { invoiceNoteAdd, invoiceSingleFetch, invoice, reset } = this.props;

    const newNote = {
      note: values.note,
      invoice: `/invoices/${invoice.id}`,
    };

    return invoiceNoteAdd(newNote).then(() => {
      reset();
      invoiceSingleFetch(invoice.id);
    });
  }

  render() {
    const { handleSubmit, error, invoice, pristine, submitting, isAddingInvoiceNote } = this.props;

    if (!invoice) {
      return <MASpinner />;
    }

    return (
      <div className="invoice-batch-single__section mb-3">
        <div className="invoice-batch-single__section-icon">
          <i className="fas fa-edit" />
        </div>
        <h2 className="invoice-batch-single__section-header">Leave a Note</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
          <Field name="note" label="Message" id="note" rows="3" type="textarea" component={renderField} />

          {isAddingInvoiceNote ? (
            <MASpinner />
          ) : (
            <button type="submit" disabled={pristine || submitting} className="btn btn-primary btn-block">
              Save Note
            </button>
          )}
        </Form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'InvoiceCreateNoteForm',
})(connect(null, mapDispatchToProps)(CreateInvoiceNoteForm));
